'use client';

import CalculatorResults from '@/components/blocks/FindYourPower/CalculatorResults';

const appendPercentage = value => (value === 0 || value ? `${value}%` : 'N/A');

export default function OUIXIndex({ title = {}, labels, footer, ouixIndex }) {
  const { current_ouixindex_value, ouix_discount } = labels;

  const { label, value } = title;

  return (
    <div className='ouix-index-viewr'>
      <p className='flex flex-wrap items-center gap-x-3 pl-4 sm:pl-8 font-light pb-2'>
        <span className='label text-primary'>{label}</span> {value}
      </p>
      <div
        className='flex flex-col gap-5 border border-primary/10 rounded-xl p-4 sm:p-8 lg:max-w-lg w-full backdrop-blur [&_.calculator-results_.item]:col-span-full [&_.calculator-results_.item]:text-center md:min-w-[32rem]'
        style={{
          backgroundImage: 'linear-gradient(180deg, hsla(var(--primary)/0.05) 0%, hsla(var(--primary)/0.20) 100%)'
        }}
      >
        <CalculatorResults
          title={current_ouixindex_value}
          subtitle={`${Math.floor(ouixIndex?.index)}`}
          list={[{ label: ouix_discount, value: appendPercentage(ouixIndex?.discount) ?? 'N/A' }]}
        />

        {footer && (
          <div className='footer link-primary text-center prose' dangerouslySetInnerHTML={{ __html: footer }} />
        )}
      </div>
    </div>
  );
}
